import { render, staticRenderFns } from "./global_alerts.vue?vue&type=template&id=cd883a5c"
import script from "./global_alerts.vue?vue&type=script&lang=js"
export * from "./global_alerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports